export default __webpack_public_path__ + "static/media/whatsappClone.09d42293.png";